import React from "react";
import ReactDOM from "react-dom/client";
import "@/styles/fonts";
import "@/styles/globals.css";
import { App } from "@/App";
import { installErrorReporter } from "@/lib/errorReporter";

installErrorReporter();

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Missing #root element");

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
